import React, { useState, useRef } from "react"
import pageMessageBroker from './page_message_broker';

export default function FileUpload({htmlId, htmlName, className, multiple = false, onChange = () => {}}) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    fileInputRef.current.files = files;
    setFiles(files);
    onChange(files);
    console.log(files);
  };

  const filePresent = files && files.length > 0;
  const blankClass = "border-dashed border-gray-300";
  const dragOverClass = "border-dashed border-blue-500 bg-blue-50";
  const dropZoneClass = isDragging ? `${blankClass} ${dragOverClass}` : blankClass;
  const presentClass = "border-solid border-material-500 bg-material-50";

  return (
    <div
      onClick={(e) => { fileInputRef.current.click() }}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
      className={`cursor-pointer border-2 rounded-lg p-4 text-center text-wrap ${filePresent ? presentClass : dropZoneClass} ${className}`}
    >
      {
        filePresent ? (
          <div className="text-material-600">
            {
              files.length > 1
                ? `${files.length} files selected`
                : fileInputRef.current.files[0].name
            }
          </div>
        ) : (
          <div className="text-gray-500">
            {multiple ? "Drag files here or click to upload" : "Drag a file here or click to upload"}
          </div>
        )
      }
      <input
        type="file"
        id={htmlId}
        name={htmlName}
        ref={fileInputRef}
        multiple={multiple}
        style={{ display: 'none' }}
        onChange={(e) => {setFiles(e.target.files); onChange(e.target.files)} }
      />
    </div>
  )
}
